import { BlogPost } from './types';

export const productivityPosts: BlogPost[] = [
  {
    id: '3',
    slug: 'time-management-tips-competitive-exams',
    title: 'Mastering Time Management for Competitive Exams',
    excerpt: 'Learn how to balance your study schedule, maximize productivity, and still maintain a healthy lifestyle during exam preparation.',
    content: `
      <p>Time management is perhaps the most critical skill for competitive exam preparation. With vast syllabi and limited time, efficient planning can make the difference between success and falling short.</p>

      <h2>Understanding Your Time</h2>
      <p>Before planning, track how you currently spend your time for one week. You'll likely find several hours that can be optimized.</p>

      <h2>The 70-20-10 Rule</h2>
      <ul>
        <li><strong>70%</strong> - Core subjects and weak areas</li>
        <li><strong>20%</strong> - Practice tests and revision</li>
        <li><strong>10%</strong> - Buffer time for unexpected situations</li>
      </ul>

      <h2>Creating Your Study Schedule</h2>
      <h3>Morning Hours (6 AM - 10 AM)</h3>
      <p>Your brain is freshest in the morning. Use this time for the most challenging subjects like Physics and Mathematics.</p>

      <h3>Afternoon (2 PM - 6 PM)</h3>
      <p>Energy dips post-lunch. Focus on easier topics or practice problems during this time.</p>

      <h3>Evening (7 PM - 10 PM)</h3>
      <p>Good for revision, Chemistry, and Biology. End with light revision before bed.</p>

      <h2>Productivity Tools</h2>
      <ul>
        <li>Use apps like Forest or Focus@Will for concentration</li>
        <li>Set specific, measurable daily goals</li>
        <li>Use the two-minute rule: if something takes less than 2 minutes, do it immediately</li>
      </ul>

      <h2>Avoiding Common Pitfalls</h2>
      <ul>
        <li>Don't overstudy—quality trumps quantity</li>
        <li>Avoid social media during study hours</li>
        <li>Don't skip breaks—they're essential for retention</li>
        <li>Plan your weeks, but remain flexible for adjustments</li>
      </ul>

      <h2>Weekly Review</h2>
      <p>Every Sunday, review what you've accomplished, what worked, what didn't, and adjust your schedule accordingly.</p>
    `,
    author: {
      name: 'Anita Desai',
      role: 'Productivity Coach'
    },
    category: 'Productivity',
    tags: ['Time Management', 'Productivity', 'Study Planning'],
    featuredImage: 'https://images.unsplash.com/photo-1501139083538-0139583c060f?w=800&h=400&fit=crop',
    publishedDate: '2025-01-05',
    readTime: '7 min read',
    views: 1800
  }
];
